$(document).ready(function() {

    const $inputFile = $(".js-input-file"),
        $inputLabel = $(".js-input-file-label");

    if($inputFile.length) {

        $inputFile.change(function() {

            if ($(this).val() != "") {
                $inputLabel.text($(this)[0].files[0].name);
            } else {
                $inputLabel.html("Прикерпить файл <span class='gray'>(pdf,xml)</span>");
            }

        });

    }

});
